"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partsToMF = partsToMF;
const partToMF_1 = require("./partToMF");
function partsToMF(parts, options) {
    let mf = [];
    for (let part of parts) {
        mf.push((0, partToMF_1.partToMF)(part, options));
    }
    return mf.join(' . ');
}
//# sourceMappingURL=partsToMF.js.map